import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AccountService } from '../auth/account.service';
import { PagePermissionsService } from '../auth/page-permissions.service';

@Injectable()
@Pipe({
    name: 'filterMenuByPermissions',
    standalone: false
})
export class FilterMenuByPermissionsPipe implements PipeTransform {

  constructor(
    private accountService: AccountService,
    private pagePermissions: PagePermissionsService
  ) { }

  transform(menuItems: MenuItem[]): MenuItem[] {
    if (!this.accountService.isAuthenticated() || !menuItems) {
      return [];
    }
    return this.filterMenuItems(menuItems);
  }

  private filterMenuItems(items: MenuItem[]): MenuItem[] {
    return items
      .map(item => {
        if (item.items && item.items.length > 0) {
          const filteredSubItems = this.filterMenuItems(item.items);
          if (filteredSubItems.length > 0) {
            return { ...item, items: filteredSubItems };
          }
          return null;
        }
        return this.hasPermission((item as any).permission) ? item : null;
      })
      .filter(item => item !== null);
  }

  private hasPermission(permission: string | string[] | { any?: string[], all?: string[] }): boolean {
    if (!permission) return true;

    try {
      if (typeof permission === 'object' && !Array.isArray(permission)) {
        if (permission.any && permission.any.length > 0) {
          return permission.any.some(perm => this.checkSinglePermission(perm));
        }
        if (permission.all && permission.all.length > 0) {
          return permission.all.every(perm => this.checkSinglePermission(perm));
        }
        return false;
      }

      if (Array.isArray(permission)) {
        return permission.some(perm => this.checkSinglePermission(perm));
      }

      return this.checkSinglePermission(permission);
    } catch (error) {
      console.error('Erreur lors de la vérification des permissions:', error);
      return false;
    }
  }

  private checkSinglePermission(permission: string): boolean {
    if (!permission) return false;

    const [page, action] = permission.split('.');
    return this.pagePermissions.hasPagePermission(page, action, true);
  }

}
